<template>
    <div class="body-panel dataContent">
        <template v-if="report != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>

                        <p class="caption-help margin-right-10" v-if="report.new">Новый отчёт</p>
                        <p class="caption-help margin-right-10" v-if="!report.new">Статус: {{ report.StateFormatted }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex" data-toggle="buttons">
                        <!--
                        states:
                        NotApproved=1,
                        Approved = 2,
                        Edited = 3,
                        OnEdition = 4,
                        Cancelled = 5
                        -->
                        <template v-if="info.User && hasClaims(info.User.DynamicRole, claimEnums.reportAdd) && report.canBeEdited">
                            <span class="caption-help margin-right-10">
                                {{ getEditProcessState() }}
                            </span>
                            <button type="button" class="btn btn-primary"
                                    @click="saveReport()"
                                    v-if="(report.new || report.State === 1 || report.State === 3 || report.State === 4) && report.ReportItems.length && photoFieldsValid">
                                Сохранить
                            </button>
                        </template>

                        <button type="button" class="btn btn-primary"
                                @click.stop="tryApproveReport()"
                                v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.reportCheck) || info.User.MainRole === 'administrators')
                                    && (report.State === 1 || report.State === 3 || report.State === 5)">
                            Принять
                        </button>
                        <button type="button" class="btn btn-delete"
                                @click.stop="sendReportToEditionModal()"
                                v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.reportCheck) || info.User.MainRole === 'administrators')
                                    && (report.State === 1 || report.State === 2 || report.State === 3)">
                            Доработать
                        </button>
                        <button type="button" class="btn btn-delete"
                                @click.stop="rejectReportModal()"
                                v-if="info.User && (info.User.MainRole === 'administrators' || hasClaims(info.User.DynamicRole, claimEnums.reportCheck)) && (report.State !== 5)">
                            Отклонить
                        </button>

                        <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                                         class="file-upload-zone-btn" accept=".xlsx" @change="onFileChange()" />
                        <button type="button" class="btn" onclick="document.getElementById('dropFiles').click()" v-if="ReportExcelEnabled">
                            Импорт
                        </button>
                        <button type="button" class="btn" @click="cancel()">Отмена</button>
                        <button type="button" class="btn btn-delete" @click="deleteReport()" v-if="!report.new && report.State !== 2 && info.User && info.User.MainRole === 'administrators'">Удалить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page" @scroll="onReportItemsScroll">
                    <div class="report-block-items">
                        <div style="padding: 30px; background: #fff;">

                            <div class="form-field" v-if="report.new && report.TradePoint == null">
                                <div>
                                    <div class="body-panel-control-separator flex">
                                        <input type="text" v-model="ttSearch" value="1" @input="onChangeTradeSearch" class="input-text" placeholder="Введите название или адрес торговой точки, после чего выберите из списка"/>
                                        <div class="switch margin-left-10">
                                            <input type="checkbox" id="s5" checked="checked" v-model="ttAllowed" @change="onChangeTradeAllowed" />
                                            <label class="slider-v3" for="s5"></label>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <br>
                                    <table class="table-view" id="dataTable">
                                        <tbody>
                                            <tr v-for="item of ttData">
                                                <td>{{item.FullName}}</td>
                                                <td class="phone">
                                                    <button v-if="!item.Error" type="button" class="btn btn-primary" @click="onSelectTradePoint(item)" style="display:unset">Добавить</button>
                                                    <span v-if="item.Error">
                                                        {{item.Error}}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div v-if="ttSearched && !ttData.length && !ttIsLoading">
                                        <span>Ничего не найдено...</span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="report.TradePoint && !report.TradePoint.Error">
                                <p v-if="report.Seller">ФИО: <strong>{{ report.Seller.Fio }}</strong></p>
                                <p v-if="report.Seller && report.Seller.DynamicRole">Роль: <strong>{{ report.Seller.DynamicRole.Name }}</strong></p>
                                <p>Торговая точка: <strong>{{ formatTradePointName(report.TradePoint) }}</strong></p>
                            </div>

                            <div class="error" v-if="report.TradePoint && report.TradePoint.Error">
                                {{ report.TradePoint.Error }}
                            </div>

                            <div class="error" v-if="report.EditionComment && report.State === 4">
                                {{ report.EditionComment }}
                            </div>
                            <div class="error" v-else-if="report.EditionComment">
                                Ранее отчет был отправлен на доработку с комментарием: {{report.EditionComment}}
                            </div>

                            <div class="error" v-if="report.CancellationComment && report.State === 5">
                                {{ report.CancellationComment }}
                            </div>

                            <div v-if="tradePointSelected && reportDateSettings && reportDateSettings.ReportDateRequired">
                                {{reportDateSettings.ReportDateCaption}}:
                                <input-date name="ReportDateFormatted" v-if="report.canBeEdited" style="margin-top: 10px;"
                                            v-validate="'required'"
                                            v-model="report.ReportDateFormatted"
                                            @input="onChangeDate(report, 'ReportDateFormatted', 'ReportDate')"
                                            :class="['input-date', {'input-error': errors.has('ReportDateFormatted')}]"></input-date>
                                <span v-if="!report.canBeEdited">
                                    {{report.ReportDateFormatted}}
                                </span>
                            </div>

                        </div>
                        <report-items-table ref="reportItems"
                                            v-if="tradePointSelected && reportSettings != null"
                                            v-model="report.ReportItems"
                                            :bonusSettings="bonusSettings"
                                            :tradePoint="report.TradePoint"
                                            :reportSettings="reportSettings"
                                            :equipmentTypes="equipmentTypes"
                                            :sku="sku"
                                            :dateToBonus="dateToBonus"
                                            :canBeEdited="report.canBeEdited"
                                            :maxItems="maxItems"></report-items-table>
                    </div>
                    <div class="report-block-photo" v-if="tradePointSelected">
                            <div class="row report-photo-field" v-for="field of reportFields">
                                <h2 :class="{'has-error': field.Required && !report.Photos.filter(x => x.FieldId === field.Id).length}">{{field.Name}}</h2>
                                <div class="row">
                                    <div class="thumbnail-img-block">
                                        <div :class="['thumbnail-img', {'thumbnail-img-file' : img.TypeId == ReportPhotoTypes.File}]" v-for="(img, i) of report.Photos.filter(x => x.FieldId === field.Id)">
                                          <template v-if="img.TypeId == ReportPhotoTypes.File">
                                              <span v-if="img.FileData">{{img.FileName}}</span>
                                              <a target="_blank" v-if="!img.FileData && img.FileName" :href="img.FileName">
                                                {{img.FileName.replace('https://storage.yandexcloud.net/foxinbox/uploads/reports/', '')}}
                                              </a>

                                              <div class="thumbnail-img-delete" @click="removeFile(i)" v-if="report.canBeEdited"></div>
                                            </template>
                                            <template v-else>
                                              <a target="_blank" v-if="img.FileData">
                                                <img :src="img.FileData" />
                                              </a>
                                              <a target="_blank" v-if="!img.FileData && img.FileName" :href="img.FileName" class="lightzoom" rel="group">
                                                <img :src="img.FileName" />
                                              </a>

                                              <div class="thumbnail-img-delete" @click="removeImage(i, field.Id)" v-if="report.canBeEdited"></div>
                                              <div class="thumbnail-img-replace" @click="" style="display:none" v-if="report.canBeEdited"></div>
                                              <div class="thumbnail-img-rotateleft" @click="rotateImage('left', img)" v-if="report.canBeEdited && !img.FileData"></div>
                                              <div class="thumbnail-img-rotateright" @click="rotateImage('right', img)" v-if="report.canBeEdited && !img.FileData"></div>

                                            </template>

                                            <span class="badge badge-danger"
                                                  v-if="img.statusMessage != null"
                                                  :title="img.statusMessage">
                                                <b>!</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="file-upload-zone" style="height:60px; width: 50%;" v-if="report.canBeEdited">
                                            <input type="file" class="file-upload-zone-btn" multiple
                                                   :id="'dropFiles' + field.Id" name="dropFilesPhotos"
                                                   :data-fieldid="field.Id" :data-typeid="field.TypeId"
                                                   :accept="getAvailableExtensions(field)" />
                                            <label :for="'dropFiles' + field.Id" class="file-upload-zone-lbl">
                                              {{ (field.PdfAndExcelFilesEnabled ? 'Добавить файл' : 'Добавить фото') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

<!--                            <div class="row report-photo-field" v-if="ReportPdfAndExcelFilesEnabled">
                                <h2>Прикрепить файл</h2>
                                <div class="row">
                                    <div class="thumbnail-img-block">
                                        <div class="thumbnail-img thumbnail-img-file" v-for="(img, i) of report.Photos.filter(x => x.TypeId === ReportPhotoTypes.File)">
                                            <span v-if="img.FileData">{{img.FileName}}</span>
                                            <a target="_blank" v-if="!img.FileData && img.FileName" :href="img.FileName">
                                                {{img.FileName.replace('https://storage.yandexcloud.net/foxinbox/uploads/reports/', '')}}
                                            </a>

                                            <div class="thumbnail-img-delete" @click="removeFile(i)" v-if="report.canBeEdited"></div>
                                            <span class="badge badge-danger"
                                                  v-if="img.statusMessage != null"
                                                  :title="img.statusMessage">
                                                <b>!</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="file-upload-zone" style="height:60px; width: 50%;" v-if="report.canBeEdited">
                                        <input type="file" id="dropFilesExternal" name="dropFilesExternal" class="file-upload-zone-btn" accept=".pdf,.xlsx" multiple />
                                        <label for="dropFilesExternal" class="file-upload-zone-lbl">Добавить</label>
                                    </div>
                                </div>
                            </div>-->

                    </div>
            </div>

            <popup-window ref="ppEditModal" :title="'Отправка на доработку'" :modal="true">
                <div class="form-group">
                    <label class="input-text-lbl">
                        Причина отправки на доработку
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <textarea name="EditionComment" rows="10" style="height:150px;"
                              :class="['input-memo', { 'input-error': errors.has('EditionComment', 'edition') }]"
                              v-model="report.EditionComment"
                              data-vv-scope="edition"
                              v-validate="'required'"></textarea>
                    <span class="field-validation-valid" v-if="errors.has('EditionComment', 'edition')">Заполните поле</span>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn btn-primary" @click.stop="sendReportToEdition()">Принять</button>
                    <button type="button" class="btn" @click.stop="closeModal('ppEditModal')">Отмена</button>
                </div>
            </popup-window>

            <popup-window ref="ppApproveModal" :title="'Принятие отчёта'">
                <div class="form-group">
                    <label class="input-text-lbl">
                        Причины изменения отчета
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <textarea name="ModificationComment" rows="10" style="height:150px;"
                              :class="['input-memo', { 'input-error': errors.has('ModificationComment') }]"
                              v-model="report.ModificationComment"
                              v-validate="'required'"></textarea>
                    <span class="field-validation-valid" v-if="errors.has('ModificationComment')">Заполните поле</span>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn btn-primary"
                            @click.stop="approveReport()"
                            :disabled="!report.ModificationComment || report.ModificationComment.length < 3">
                        Принять
                    </button>
                    <button type="button" class="btn" @click.stop="closeModal('ppApproveModal')">Отмена</button>
                </div>
            </popup-window>

            <popup-window ref="ppRejectModal" :title="'Отклонение отчёта'">
                <div class="form-group">
                    <label class="input-text-lbl">
                        Укажите причину отклонения
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <textarea name="CancellationComment" rows="10" style="height:150px;"
                              :class="['input-memo', { 'input-error': errors.has('CancellationComment', 'rejection') }]"
                              data-vv-scope="rejection"
                              data-vv-as="Причина отклонения"
                              v-model="report.CancellationComment"
                              v-validate="{required: true, min: 3}"></textarea>
                    <span class="field-validation-valid">{{errors.first('CancellationComment', 'rejection')}}</span>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn btn-primary"
                            @click="rejectReport()">Отклонить</button>
                    <button type="button" class="btn" @click="closeModal('ppRejectModal')">Отмена</button>
                </div>
            </popup-window>

            <popup-window ref="ppImportResultsModal" :title="'Результаты импорта'">
                <div v-if="importResult != null">
                    Успешно импортировано строк: {{ importResult.Data.length }}<br><br>
                    <template v-if="importResult.Errors.length">
                        Ошибки:<br>
                        <ul>
                            <li v-for="error of importResult.Errors">
                                {{error}}
                            </li>
                        </ul>
                    </template>
                </div>
                <div class="btns flex margin-top-20" data-toggle="buttons">
                    <button type="button" class="btn" @click="closeModal('ppImportResultsModal')">Ok</button>
                </div>
            </popup-window>
        </template>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import ReportItemsTable from '../../components/ReportItemsTable'
    import projectMixin from '../../helpers/project-mixin'
    import fancybox from '../../assets/FancyBox/jquery.fancybox.pack.js'
    import fancyboxcss from '../../assets/FancyBox/jquery.fancybox.css'
    import jqueryui from '../../assets/JqueryUI/jquery-ui.min'
    import moment from 'moment'
    import config from '../../config'
    import minusIcon from '../../../img/icon-minus-2.png'
    import {ReportPhotoTypes} from '../../enums'

    let backendApi = new BackendApi();
    export default {
        name: "report-edit",

        mixins: [projectMixin],

        props: ['info'],

        data() {
            return {
                report: null,
                origin: null,
                reportSettings: null,
                equipmentTypes: [],
                sku: [],
                reportFields: null,
                reportDateSettings: null,
                importResult: null,
                ReportExcelEnabled: false,
                ReportOnlyOneItemAllowed: false,
                bonusSettings: null,
                ReportPdfAndExcelFilesEnabled: false,
                dateToBonus: { reportDate: null},

                ttSearch: null,
                ttAllowed: true,
                ttData: [],
                ttPage: 1,
                ttIsLoading: false,
                ttCanBeLoaded: true,
                ttSearched: false,
                ReportPhotoTypes: ReportPhotoTypes
            }
        },

        components: { ReportItemsTable },

        computed: {
            tradePointSelected() {
                return this.report.TradePoint && this.report.TradePoint.Id && this.report.TradePoint.Error == null;
            },

            photoFieldsValid(){
                let photoError = false;
                for(let field of this.reportFields){
                    if(field.Required && !this.report.Photos.filter(x => x.FieldId === field.Id).length){
                        photoError = true;
                        break;
                    }
                }

                return !photoError;
            },

            maxItems(){
                return this.ReportOnlyOneItemAllowed === true ? 1 : 0;
            }
        },

        methods: {
            getAvailableExtensions(field){
              return ['.jpg','.jpeg','.png', ...(field.PdfAndExcelFilesEnabled === true ? ['.pdf', '.xlsx'] : [])];
            },

            onFileChange() {
                let vm = this;
                let files = document.getElementById('dropFiles').files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        //let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        vm.importResult = null;

                        this.callApiWrapper(backendApi.reportImport(vm.projectId, data)).then(function (response) {
                            document.getElementById('dropFiles').value = '';
                            if (response.hasError) {
                                UI.toastr.error('Ошибка импорта');
                            }
                            else {
                                if (response.data) {
                                    vm.importResult = response.data;

                                    if(vm.$refs.reportItems){
                                        vm.$refs.reportItems.importItems(vm.importResult.Data);
                                    }

                                    vm.$refs['ppImportResultsModal'].show();
                                }
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            back() {
                this.$router.push('/reports');
            },

            cancel() {
                this.$router.back();
                console.info('this', this)
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            getEditProcessState(){
                if(this.report.new && !this.tradePointSelected){
                    return 'Выберите торговую точку...';
                }
                if(!this.report.ReportItems.length){
                    return 'Добавьте информацию в таблицу...';
                }

                let photoError = false;
                for(let field of this.reportFields){
                    if(field.Required && !this.report.Photos.filter(x => x.FieldId === field.Id).length){
                        photoError = true;
                        break;
                    }
                }

                if(photoError && this.info.User.MainRole !== 'administrators'){
                    return 'Добавьте фотоотчет...';
                }
            },

            formatTradePointName(tradePoint) {

                let arr = [];
                if (tradePoint.Region) {
                    arr.push(tradePoint.Region)
                }
                if (tradePoint.City) {
                    arr.push(tradePoint.City)
                }
                if (tradePoint.Address) {
                    arr.push(tradePoint.Address)
                }

                return tradePoint.Name + ( arr.length ? ' (' + arr.join(', ') + ')' : '');
            },

            loadReport() {
                let that = this;
                let id = parseInt(this.$route.params.id);

                return this.callApiWrapper(backendApi.reportLoad(id, that.projectId)).then(function (response) {
                    //console.info('details -> load, response:', JSON.stringify(response.data));
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке отчета');
                    }
                    else {
                        if (response.data) {
                            if (id === 0) {
                                that.report = {
                                    new: true,
                                    ReportItems: [],
                                    Photos: [],
                                    TradePoint: null,
                                    ProjectId: that.projectId,
                                    canBeEdited: true,
                                    ReportDateFormatted: null
                                };
                                if (response.data.reportDateSettings.ReportDateRequired && response.data.reportDateSettings.ReportDateDefault) {
                                    that.report.ReportDateFormatted = that.formatDate(moment());
                                    that.report.ReportDate = moment().format();
                                }

                                if (response.data.tradePoint) {
                                    that.report.TradePoint = response.data.tradePoint;
                                }
                                else {
                                    that.loadNextTradePoints();
                                }
                                that.dateToBonus.createDate = that.report.ReportDate;
                                that.dateToBonus.approvementDate = null;
                            } else {
                                that.report = response.data.report;

                                if (that.info && that.info.User) {
                                    // продавцы могут редактировать новый отчет, доработанный или на доработке
                                    if (((that.report.State === 1 || that.report.State === 4 || that.report.State === 3) && that.hasClaims(that.info.User.DynamicRole, that.claimEnums.reportAdd)) ||
                                        ((that.report.State === 1 || that.report.State === 3) && (that.hasClaims(that.info.User.DynamicRole, that.claimEnums.reportCheck) || that.info.User.MainRole === 'administrators'))) {
                                        that.report.canBeEdited = true;
                                    }
                                    else {
                                        that.report.canBeEdited = false;
                                    }
                                }

                                that.report.ReportDateFormatted = that.formatDate(response.data.report.ReportDate);

                                that.origin = JSON.parse(JSON.stringify(response.data.report));
                                that.dateToBonus.createDate = that.report.CreateDate;
                                that.dateToBonus.approvementDate = that.report.ApprovementDate;
                            }
                            //console.info('response.data.reportSettings', response.data.reportSettings)
                            that.reportSettings = response.data.reportSettings;
                            that.bonusSettings = response.data.bonusSettings;
                            that.sku = response.data.sku; // узкое место - лучше грузить непосредственно при выборе sku в dropdown'e в таблице
                            that.equipmentTypes = response.data.equipmentTypes;
                            that.reportFields = response.data.fields;
                            that.reportDateSettings = response.data.reportDateSettings;

                            that.ReportExcelEnabled = response.data.ReportExcelEnabled;
                            that.ReportOnlyOneItemAllowed = response.data.ReportOnlyOneItemAllowed;
                            that.ReportPdfAndExcelFilesEnabled = response.data.ReportPdfAndExcelFilesEnabled;
                            that.dateToBonus.reportDate = that.report.ReportDate;
                            if (that.bonusSettings.bonusStrategy.type === 'data') {
                                that.bonusSettings.bonusStrategy.data.dateBonusItems = [];
                                for (let s of that.bonusSettings.bonusStrategy.data.ValueItems) {
                                    let item = {};
                                    for (let field of s.Fields) {
                                        switch (field.Name) {
                                            case 'value': item.value = field.Value; break;
                                            case 'dateBeg': item.dateBeg = moment(field.Value, 'DD.MM.YYYY'); break;
                                            case 'dateEnd': item.dateEnd = moment(field.Value, 'DD.MM.YYYY'); break;
                                        }
                                    }
                                    that.bonusSettings.bonusStrategy.data.dateBonusItems.push(item);
                                }
                            }
                            console.info('that.bonusSettings', that.bonusSettings);
                        }
                    }
                }).catch(function (response) {
                    console.info('catch', response)
                });
            },


            saveReport() {
                let vm = this;

                // проверяем фотки
                if (!vm.photoFieldsValid && vm.info.User.MainRole !== 'administrators' && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.reportCheck)) {
                    UI.toastr.error('Нужно добавить фотографий к отчёту');
                }
                else {
                    Promise.all([vm.$refs.reportItems.validate(), vm.$validator.validate()]).then(results => {
                        if (!results[0] || !results[1]) {
                            UI.toastr.error('Проверьте введённые данные');
                        }
                        else {
                            UI.blockUI('.dataContent', 'Сохранение...');

                            let saveObj = Object.assign({}, vm.report);
                            if(vm.reportDateSettings && vm.reportDateSettings.ReportDateRequired){
                                let timeZone = new Date().getTimezoneOffset();
                                saveObj.ReportDate = moment(vm.report.ReportDateFormatted, 'DD.MM.YYYY').add(-timeZone, 'minutes').toISOString();
                            }

                            backendApi.reportSave(saveObj).then(function (response) {
                                console.info('details -> reportSave, response:', response.data);
                                UI.unblockUI('.dataContent');
                                if (response.hasError) {
                                    UI.toastr.error('Ошибка при сохранении отчета');
                                } else {
                                    UI.toastr.success('Успешно сохранено');
                                    vm.$router.push('/reports');
                                }
                            });
                        }
                    });
                }
            },


            //показываем окно с вводом комментария
            sendReportToEditionModal() {
                let vm = this;
                vm.$nextTick(() => {
                    vm.$refs.ppEditModal.show();

                });
            },

            // отправка на доработку
            sendReportToEdition() {
                let vm = this;
                vm.$validator.validateAll('edition').then(result => {
                    if (result) {
                        vm.report.State = 4;
                        vm.saveReport();
                        vm.$refs['ppEditModal'].close();
                    }
                });
            },

            // принятие отчёта
            tryApproveReport() {
                let vm = this;

                // проверяем что ничего в отчёте не менялось контролёром
                // если поменялось - показываем окно с комментарием
                if (this.isReportChanged()) {
                    vm.$nextTick(() => {
                        vm.$refs.ppApproveModal.show();
                    });
                }
                else {
                    this.report.State = 2;
                    this.report.ModificationComment = '';
                    this.saveReport();
                }
            },

            approveReport() {

                if (!this.report.ModificationComment) {
                    return;
                }

                this.report.State = 2;
                this.$refs['ppApproveModal'].close();
                this.saveReport();
            },

            closeModal(popupName) {
                this.$refs[popupName].close();
            },

            rejectReportModal() {
                let vm = this;
                vm.$nextTick(() => {

                    vm.$refs.ppRejectModal.show();

                });
            },

            rejectReport() {
                let vm = this;
                vm.$validator.validateAll('rejection').then(result => {
                    if (result) {
                        this.$refs.ppRejectModal.close();
                        this.report.State = 5;
                        this.saveReport();
                    }
                });
            },

            deleteReport() {
                if (confirm('Вы уверены, что хотите удалить отчет?')) {
                    if(confirm('Отчет будет удален безвозвратно! Подтвердите действие!')) {
                        let vm = this;
                        UI.blockUI('.dataContent', 'Удаление...');

                        backendApi.reportDelete(vm.report.Id).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при удалении отчета');
                            } else {
                                UI.toastr.success('Успешно удалено');
                                vm.$router.push('/reports');
                            }
                        });
                    }
                }
            },

            onSelectTradePoint(tt){
                this.report.TradePoint = tt;
            },

            onChangeTradeSearch : _.debounce(function () {
                this.ttPage = 1;
                this.ttData = [];
                this.loadNextTradePoints();
            }, 300),

            onChangeTradeAllowed(){
                this.ttPage = 1;
                this.ttData = [];
                this.loadNextTradePoints();
            },

            onReportItemsScroll(e){
                let vm = this;
                if (vm.report.TradePoint == null && !vm.ttIsLoading && vm.ttCanBeLoaded) {
                    let elem = $(e.target);
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.ttPage++;
                        vm.loadNextTradePoints();
                    }
                }
            },

            loadNextTradePoints(){
                let vm = this;

                vm.ttSearched = true;

                let searchText = vm.ttSearch;
                vm.ttIsLoading = true;
                UI.blockUI('.dataContent', 'Загрузка...');
                vm.callApiWrapper(backendApi.tradePointListForReport((this.ttPage - 1) * 50, 50, vm.projectId, searchText, vm.ttAllowed))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки торговых точек');
                        }
                        else {
                            if (resp.data && resp.data.length) {
                                vm.ttData.push(...resp.data);
                            }
                            else {
                                vm.ttCanBeLoaded = false;
                            }
                        }

                        UI.unblockUI('.dataContent');
                        vm.ttIsLoading = false;
                    })

            },

            removeImage(i, fieldId) {
                if (confirm('Удалить изображение?')) {
                    let k = 0, index = 0;
                    for(let x of this.report.Photos){
                        if(x.FieldId === fieldId){
                            if(k===i){
                                this.report.Photos.splice(index, 1);
                                break;
                            }
                            k++;
                        }
                        index++;
                    }
                }
            },

            removeFile(i) {
                if (confirm('Удалить файл?')) {
                    let k = 0, index = 0;
                    for (let x of this.report.Photos) {
                        if (x.TypeId === ReportPhotoTypes.File) {
                            if (k === i) {
                                this.report.Photos.splice(index, 1);
                                break;
                            }
                            k++;
                        }
                        index++;
                    }
                }
            },

            rotateImage(direction, img){
                let vm = this;

                vm.callApiWrapper(backendApi.rotateReportImage(img.Id, direction))
                    .then(function (response) {
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при изменении изображения');
                        } else {
                            img.FileName = response.data;
                        }
                    });
            },

            isReportChanged() {
                return JSON.stringify(this.report) !== JSON.stringify(this.origin);
            },

            zoomIn(){
                let $img = $.fancybox.wrap.find('img.fancybox-image');
                let scale = $img.data('scale') || 1.0;
                scale += 0.2;
                $img.css('transform','scale('+(scale)+')');
                $img.data('scale', scale);
            },

            zoomOut(){
                let $img = $.fancybox.wrap.find('img.fancybox-image');
                let scale = $img.data('scale') || 1.0;
                scale -= 0.2;
                if(scale < 0.5){
                    return false;
                }
                $img.css('transform','scale('+(scale)+')');
                $img.data('scale', scale);
            }
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            vm.loadReport().then(() => {
                UI.unblockUI('.dataContent');

                $(document).on('change', '[name="dropFilesPhotos"]', function () {
                    let fieldId = $(this).data('fieldid');
                  console.info('dropFilesPhotos -> typeId:', $(this).data('typeid'))
                    if (this.files && this.files.length) {
                        for (let file of this.files) {
                            if (file.size > 50 * 1024 * 1024) {
                                UI.toastr.error('Превышен размер. Выберите другой файл');
                                $('[name="dropFiles"]').val('');
                            } else {
                              console.info('file:', file);
                              let typeId = 0;
                              if(file.name.indexOf('.xlsx') > -1 || file.name.indexOf('.pdf') > -1){
                                typeId = ReportPhotoTypes.File;
                              }
                                let img = { FileName: file.name, FileData: null, Delete: false, FieldId: fieldId, TypeId: typeId };
                                let reader = new FileReader();
                                reader.onload = function (e) {
                                    img.FileData = e.target.result;

                                    vm.report.Photos.push(img);

                                  /*$('.lightzoom').fancybox({
                                    beforeShow: function () {
                                      let downloadpath = $.fancybox.wrap.find('.fancybox-image').attr('src');
                                      let $btn = $('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                                      $.fancybox.wrap.find('.fancybox-outer').after($btn);
                                    }
                                  });*/
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                    }
                });

                /*$(document).on('change', '[name="dropFilesExternal"]', function () {
                    let fieldId = $(this).data('fieldid');
                    if (this.files && this.files.length) {
                        for (let file of this.files) {
                            if (file.size > 50 * 1024 * 1024) {
                                UI.toastr.error('Превышен размер. Выберите другой файл');
                                $('[name="dropFilesExternal"]').val('');
                            } else {
                                let img = { FileName: file.name, FileData: null, Delete: false,
                                  TypeId: ReportPhotoTypes.File, FieldId: fieldId };
                                let reader = new FileReader();
                                reader.onload = function (e) {
                                    img.FileData = e.target.result;
                                    vm.report.Photos.push(img);
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                    }
                });
*/
                $('.lightzoom').fancybox({
                    beforeShow: function() {
                        let downloadpath = $.fancybox.wrap.find('.fancybox-image').attr('src');
                        let $btn = $('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                        let $div = $(`<div class="btns flex">
<button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>
<button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>
</div>`);
                        $.fancybox.wrap.find('.fancybox-outer').after($btn);
                        $.fancybox.wrap.find('.fancybox-outer').before($div);
                        $.fancybox.wrap.find('img.fancybox-image').draggable();
                    }
                });

                $(document).on('click', '.zoom-plus', function(){
                    vm.zoomIn();
                });
                $(document).on('click', '.zoom-minus', function(){
                    vm.zoomOut();
                });

                $(window).bind('mousewheel DOMMouseScroll', function(event){
                    if($.fancybox.wrap != null){
                        if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                            vm.zoomOut();
                        }
                        else {
                            vm.zoomIn();
                        }
                    }
                });
            });
        },


        destroyed(){
            $(window).unbind('mousewheel DOMMouseScroll');
        }
    }
</script>

<style scoped>
    button.img-download{
        left: 50%;
        position: relative;
        margin-left: -35px;
    }
    .fancybox-inner {overflow: hidden !important;}
    .fancybox-nav{width: 40px !important;}

    .thumbnail-img-file{
        width: auto;
        height: 50px;
        padding: 10px 25px 10px 10px;
    }
    .thumbnail-img-file .thumbnail-img-delete{
        right: 0px;
        bottom: 16px;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/ReportEdit.vue